import { useState } from "react";
import { Link } from "react-router-dom";
import { Page } from "../../components/page/page";
import { useLocalization } from "../../hooks/use-localization/useLocalization";
import { StatusMessage } from "../../components/status-message/statusMessage";
import { OtpForm } from "./form";
import { useApp } from "../../hooks/use-app/useApp";

export const OtpQr: React.FC = () => {
  const { localize } = useLocalization();
  const app = useApp();
  const [validated, setValidated] = useState<boolean>(false);

  return (
    <Page title={localize("otp:title")}>
      {validated ? (
        <StatusMessage type="success">OK</StatusMessage>
      ) : (
        <>
          <ol className="h4">
            <li>{localize("otp:qr:step1")}</li>
            <li>{localize("otp:qr:step2")}</li>
            <li>{localize("otp:qr:step3")}</li>
            <li>{localize("otp:qr:step4")}</li>
          </ol>
          <img
            className="qr"
            src={`/${app.name}/api/otp/qr`}
            alt={localize("otp:qr:alt")}
          />
          <OtpForm onValidate={() => setValidated(true)} />
        </>
      )}
      <Link className="button secondary" to="../" relative="path">
        {localize("back")}
      </Link>
    </Page>
  );
};
